import { Dialog } from "@mui/material";
import { TriangleAlert, X, RefreshCw } from "lucide-react";
import { type ReactElement } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useBrand } from "src/hooks/useBrand";

import { consentDialogStyles } from "./styles";

type Props = {
  open: boolean;
  onReview: () => void;
  onConfirm: () => void;
};

export function ConsentRefusalModal({
  open,
  onReview,
  onConfirm,
}: Props): ReactElement {
  const { t } = useTranslation();
  const { identity } = useBrand();
  return (
    <Dialog
      open={open}
      transitionDuration={0}
      disableEscapeKeyDown
      maxWidth={false}
      className="consent-platform-confirm-dialog"
      sx={consentDialogStyles}
      aria-labelledby="consent-refusal-title"
      aria-describedby="consent-refusal-description"
    >
      <div className="consent-platform-confirm">
        <header>
          <span className="consent-platform-warning-icon">
            <TriangleAlert />
          </span>
          <h2 id="consent-refusal-title">
            {t(
              "Vous vous apprêtez à ne recevoir aucune information de {{brandName}}",
              {
                brandName: identity.name,
              },
            )}
          </h2>
          <p id="consent-refusal-description">
            {t(
              "En dehors des échanges strictement liés à votre contrat, vous ne recevrez plus rien de notre part.",
            )}
          </p>
        </header>
        <div className="consent-platform-confirm-body">
          <strong>{t("Vous allez manquer :")}</strong>
          <ul>
            <li>
              <X aria-hidden="true" />
              <span>
                <Trans i18nKey="<strong>Les conseils</strong> pour votre logement, votre immeuble et votre quotidien pour vous aider à optimiser, développer votre patrimoine ou réaliser des économies" />
              </span>
            </li>
            <li>
              <X aria-hidden="true" />
              <span>
                <Trans i18nKey="<strong>Les alertes immobilières</strong> sur la valeur de votre logement, l'évolution de votre loyer, les biens vendus dans votre immeuble…" />
              </span>
            </li>
            <li>
              <X aria-hidden="true" />
              <span>
                <Trans i18nKey="<strong>Les offres exclusives</strong> de nos partenaires (énergie, télécom, travaux…)" />
              </span>
            </li>
            <li>
              <X aria-hidden="true" />
              <span>
                <Trans
                  i18nKey="<strong>Les événements et webinaires</strong> organisés par {{brandName}} en agence ou en ligne"
                  values={{ brandName: identity.name }}
                />
              </span>
            </li>
          </ul>
          <button
            type="button"
            className="consent-platform-button consent-platform-button-primary"
            onClick={onReview}
          >
            <RefreshCw aria-hidden="true" />
            {t("Je vérifie mes choix")}
          </button>
          <button
            type="button"
            className="consent-platform-refuse"
            onClick={onConfirm}
          >
            {t("Confirmer, je ne souhaite rien recevoir")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
